import React,{useState,useEffect} from 'react';
// import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import{Box,Button,Grid,Typography} from '@mui/material';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import CreateChild from '../Forms/CreateChild/CreateChild';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetTeamDetail } from '../../Hooks';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import {CircularProgress} from '@mui/material';
// import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import CalculateIcon from '@mui/icons-material/Calculate';
// import ScaleIcon from '@mui/icons-material/Scale';
// import DescriptionIcon from '@mui/icons-material/Description';
// import {useGetPersonPicture } from '../../../CompanyManagment/Hooks/index';
// import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import PersonIcon from '@mui/icons-material/Person';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import TeamDetailsTabs from '../TeamDetailsTabs/TeamDetailsTabs';
const TeamDetail = () => {
  const navigate=useNavigate()
  const location:any=useLocation();
  let{state}:any=location;
  let{parentId}:any=state;
const[showCreateTeam,setShowCreateTeam]=useState<Boolean|null>(false);
// let[teamId,setTeamId]=useState<any>(null);
const{data:objData,isLoading,refetch:getObjDataAgain}=useGetTeamDetail(parentId);
const[objectiveDetails,setObjectiveDetails]=useState<any>(null);
const[keyResults,setKeyResults]=useState<any>([])
const[showToastMessage,setShowToastMessage]=useState<boolean>(false);
const[addKrState,setAddKrState]=useState<any>(null);
const[showEditKr,setShowEditKr]=useState<boolean>(false);
const[krId,setKrId]=useState<string|null>(null);
// const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
const personId=useSelector((state:any)=>state.loign.personId);
// const{data:personPictureData}=useGetPersonPicture(personId);
const[imgSrc,setImgSrc]=useState<any>(null);
// let body:any={

//   personId:personId
// };

useEffect(() => {
console.log(krId)
if (krId) {
  setShowEditKr(true)
}
}, [krId])

  //   useEffect(() => {
  // //     let{state}:any=location;
  // // let{parentId}:any=state;
  //   //if (location) {
  //     // let{state:{teamId}}:any=location;
  //     setTeamId(parentId)
  //   //}
  //   }, location)

    useEffect(() => {
      
   if (objData) {
    let{name,personCount,managerName, id,chlidsTeamCount,
      pictureBase64String,objectiveCount,keyResultCount,personQueryResultDtos
    }=objData;
      setKeyResults(personQueryResultDtos)
    let objjjdata={
      id:id,
      name:name,
      personCount:personCount,
      chlidsTeamCount:chlidsTeamCount,
      managerName:managerName,
      objectiveCount :objectiveCount,
      keyResultCount:keyResultCount,
      personQueryResultDtos:personQueryResultDtos,
    }
    setObjectiveDetails(objjjdata)
   }
    }, [objData])
    
  useEffect(() => {
    if (objData) {
      let{pictureBase64String}=objData;
      setImgSrc(pictureBase64String)
    }
      }, [objData]) 

// const initialCreateTeam=():void=>{
//   setShowCreateTeam(prev=>!prev)
//   }

  const initialGoBack=()=>{
    navigate('/dashboard/companyManagment',{replace:true,state:{teamId:''}})
  }
  return (
    <>
    <Grid container  >
    <Grid item xs={12}  >
     <Box width={'100%'} boxShadow={1}
     py={2} 
     px={1} 
     display={'flex'} 
     justifyContent={'space-between'}
     flexDirection={'row-reverse'} >
     <Box>
     {/* <DyButton  
    caption={'تعریف تیم زیرمجموعه'}
    onClick={initialCreateTeam}
    disbled={false}
    variant={'contained'}
    type={'button'}
    bgColor={'#00387C'}
    /> */}
     </Box>
     <Box>
      <Typography fontSize={'14px'} fontWeight={600}   >
        جزئیات تیم
      </Typography>
     </Box>
     <Box>
      <Button variant='text' onClick={initialGoBack} startIcon={<ArrowForwardIcon/>}   >
        برگشت
      </Button>
     </Box>
     </Box>
    </Grid>

    <Grid item xs={12}  >
     {
    isLoading && <Box py={4}  textAlign={'center'}   >
      <CircularProgress/>
    </Box>
     }
     {
      !isLoading && <Grid container >
     <Grid item xs={12} px={1} >
     <Box width={'100%'}  py={5} bgcolor={'#00387C'} borderRadius={3}  >
       <Grid container  >
        <Grid item xs={12}  sx={{position:'relative'}}  >
       <Grid container 
      bgcolor={'#f9f9f9'}
       width={'90%'} 
       sx={{position:'absolute',top:'20px',mx:'auto',transform: 'translate(-50%, -50%)',left: '50%',}} 
       display={'flex'} justifyContent={'space-between'}  
       borderRadius={2}
       boxShadow={4}
       >
     <Grid item xs={12} sm={9}>
     <Box p={1}  >
       <Typography variant='body1' fontWeight={800} fontSize={'13px'} >
        نام: { objectiveDetails?.name }
        </Typography>
       </Box>
      </Grid>
      <Grid item xs={12} sm={3}>
      <Box display={'flex'}     p={{ xs: 0, sm: 1 }} // پدینگ در موبایل صفر و در صفحات بزرگتر 1
 flexDirection={'row-reverse'} justifyContent={'start'}>
     <Box display={"flex"}   flexDirection={"row-reverse"} alignItems={"center"} textAlign={"center"}>
        <Typography variant='body1' px={0.5} fontWeight={800} textAlign={'center'} fontSize={'13px'}>
         مدیر: {objectiveDetails?.managerName}
        </Typography><img src={imgSrc}
        style={{borderRadius:'50%',boxShadow:'20px',alignItems:'center'}}
         /> 
        <PersonIcon width={'15px'}  height={'15px'} /> 
        </Box>
        </Box>
     </Grid>
     <Grid item xs={12} sm={9}>
     <Box px={1}>
           <Typography variant='body2' fontWeight={700} fontSize={'13px'}>
          تعداد هدف: {objectiveDetails?.objectiveCount}
          </Typography>
    </Box>
     </Grid>
     <Grid item xs={12} sm={3}>
     <Box px={1} >
          <Typography variant='body2' fontWeight={700} fontSize={'13px'}>
            تعداد نتیجه کلیدی: {objectiveDetails?.keyResultCount}
          </Typography>
         </Box>
     </Grid>

     <Grid item xs={12} sm={3}>
     <Box width={'100%'} px={1} py={{ xs: 0, sm: 1 }}>
     <Typography variant='caption' fontWeight={900} fontSize={'13px'}>
      تعداد تیم های زیرمجموعه: {objectiveDetails?.chlidsTeamCount}
    </Typography>
    </Box> 
       </Grid>

       <Grid item xs={12} sm={3}>
       <Box width={'100%'} px={1} py={{ xs: 0, sm: 1 }}>
       <Typography variant='caption' fontWeight={900} fontSize={'13px'}>
      تعداد پرسنل: {objectiveDetails?.personCount}
    </Typography>
    </Box> 
       </Grid>
       </Grid>
        </Grid>
       </Grid>
     </Box>
     </Grid>

     {/* <Grid item xs={12} mt={4}  >
     <Grid container px={1}   
      >
       <Grid item xs={3}   >
      <Box  width={'100%'}  display={'flex'} justifyContent={'start'} p={1} >
       <Box><VisibilityIcon/></Box>
       <Box>
       <Typography  variant='caption'fontWeight={700} px={1} fontSize={'13px'} >قابلیت نمایش</Typography>
       </Box>
      </Box>
      <Box 
      width={'80%'} bgcolor={'#f9f9f9'} 
      display={'flex'} justifyContent={'start'} 
      borderRadius={3} boxShadow={1}
      p={2}
      >
        <Typography variant='caption' fontSize={'13px'} fontWeight={400}>قابلیت نمایش برای همه</Typography>
      </Box>
       </Grid>

       <Grid item xs={3}   >
      <Box  width={'100%'}  display={'flex'} justifyContent={'start'} p={1} >
      <Box><CalculateIcon/></Box>
       <Box>
       <Typography variant='caption' fontSize={'13px'} fontWeight={700} px={1}>نحوه محاسبه پیشرفت</Typography>
       </Box>
      </Box>
      <Box  width={'80%'} bgcolor={'#f9f9f9'} 
      display={'flex'} justifyContent={'start'} 
      borderRadius={3}
      p={2} boxShadow={1}> 
        <Typography variant='caption' fontWeight={400} fontSize={'12px'} >{objectiveDetails?.name}</Typography>
      </Box>
       </Grid>

       <Grid item xs={3}   >
      <Box  width={'100%'}  display={'flex'} justifyContent={'start'} p={1} >
      <Box><ScaleIcon/></Box>
       <Box>
       <Typography variant='caption'fontWeight={700} fontSize={'13px'} px={1}>وزن</Typography>
       </Box>
      </Box>
      <Box width={'80%'}  bgcolor={'#f9f9f9'} 
      display={'flex'} justifyContent={'start'} 
      borderRadius={3}
      p={2} boxShadow={1} >
        <Typography variant='caption' fontWeight={400} fontSize={'12px'} >{objectiveDetails?.name}</Typography>
      </Box>
       </Grid>


       <Grid item xs={3}   >
      <Box  width={'100%'}  display={'flex'} justifyContent={'start'} p={1} >
      <Box><CrisisAlertIcon/></Box>
       <Box>
       <Typography variant='caption'fontWeight={700} fontSize={'13px'} px={1}>دلیل اهمیت</Typography>
       </Box>
      </Box>
      <Box   
      
       >
               <Box display={'flex'} width={'100%'} height={'50px'} bgcolor={'#f9f9f9'} 
      justifyContent={'start'} 
      borderRadius={3}
      p={2} boxShadow={1}>   
       <Typography  px={1} sx={{ fontSize: '12px !important',fontWeight:'400', color: 'black',cursor:'pointer',textAlign:'left' }}    >
              
            </Typography>
          
</Box> 
      </Box>
       </Grid>
      </Grid>
     </Grid> */}
{/* 
     <Grid item xs={11}>
    <Box px={1}>
      
    <Box  width={'100%'}  display={'flex'} justifyContent={'start'} p={1} >
       <Box>
        <DescriptionIcon/>
        </Box>
       <Box>
       <Typography variant='caption' fontSize={'13px'}fontWeight={700} px={1}>توضیحات</Typography>
       </Box>
      </Box>

      <Box 
      width={'80%'} bgcolor={'#f9f9f9'} 
      display={'flex'} justifyContent={'start'} 
      borderRadius={3}
      p={2} boxShadow={1}
      >
            <Box display={'flex'}>   
         <Typography  px={1} sx={{ fontSize: '12px !important',fontWeight:'400', color: 'black',cursor:'pointer',textAlign:'left' }}    >
             

            </Typography>
          
</Box> 
       </Box>
    </Box>
     </Grid> */}
       
       <Box 
          width={'80%'} bgcolor={'#f9f9f9'} 
          display={'flex'} justifyContent={'start'} 
          borderRadius={3}
          p={2} boxShadow={1}
          >
            <Box display={'flex'}>   
         <Typography  px={1} sx={{ fontSize: '12px !important',fontWeight:'400', color: 'black',cursor:'pointer',textAlign:'left' }}    >
         </Typography>
        </Box> 
       </Box>

       <Grid item xs={12}  >
       <TeamDetailsTabs 
        krs={keyResults} 
        setKrId={setKrId}
        id = {objectiveDetails?.id}
        setShowEditKr={setShowEditKr}
        setAddKrState={setAddKrState}
        setShowToastMessage={setShowToastMessage}
       />
       </Grid>
      </Grid>
     }
    </Grid>
{/*  objectivesStateName:objectivesStateName,
      periodName:periodName */}
     {
      showCreateTeam && <ModalLyt   
      showModal={showCreateTeam}
      width={600}
      height={500}
      setShowModal={setShowCreateTeam}
      title={'ایجاد تیم'}  >
       <CreateChild
       setShowCreateTeam={setShowCreateTeam}
       addKrSuccess={getObjDataAgain}  
       parentId = {objectiveDetails?.id}
       setShowToastMessage={setShowToastMessage}
       setAddKrState={setAddKrState}
        />
      </ModalLyt>
    }
    {/* {
      showEditKr && <ModalLyt 
      showModal={showEditKr}
      setShowModal={setShowEditKr}
      title={'ویرایش نتیجه کلیدی'}
      >
      <EditKeyResult  
      definitionId = {objectiveDetails?.
        definitionLevelId}
      setShowEditKeyResult={setShowEditKr}
      editKrSuccess={getObjDataAgain}  
      setShowToastMessage={setShowToastMessage}
      setAddKrState={setAddKrState}
      krId={krId}
     
      />
      </ModalLyt>

    }  */}
    {
      showToastMessage && <DYToastMessage
      isSuccess={addKrState?.isSuccess}
      message={addKrState?.metaData.message}
      setShow={setShowToastMessage}
      show={showToastMessage}
      />      
    }
    </Grid>
    </>
  )
}

export default TeamDetail